import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_down",
  "use": "icon-arrow_down-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 5\" id=\"icon-arrow_down\">\n    <path data-name=\"Path 20\" d=\"m646.134 1012.823 5-5 5 5z\" transform=\"rotate(180 328.067 506.411)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol